import React from 'react';
import PropTypes from 'prop-types';

export default function MiddleDot({ className }) {
  return <span className={className}>&middot;</span>;
}

MiddleDot.propTypes = {
  className: PropTypes.string
};

MiddleDot.defaultProps = {
  className: null
};
